import { IModel } from '@/@types/models/model';
import coreFields from './helpers/coreFields';

const listFields = ['id', 'jls_ime', 'tip', 'zu_ime', 'jls_srediste', 'jls_mb', 'n_planova', 'has_nova_generacija'];

// JLS (jedinice lokalne samouprave) with plan counts - primary/map model for
// PPRegistarDataCentricPage (GET /prostorni-planovi/jls, action 7022), paired with
// pp_registar as the secondary (GET jls/{jls_mb}/registar). Backed by the same
// "Prostorni planovi (JLS)" WMS layer as pp_registar, so map-click selection resolves
// via the jls_mb property (GetFeatureInfo has no plain "id" field).
const JLS: IModel = {
  title: 'JLS',
  apiPath: 'prostorni-planovi/jls',
  layer: 'PP_registar',
  minimapGfiIdAttribute: 'jls_mb',
  forms: {
    default: {
      fields: listFields,
    },
  },
  listViews: {
    default: {
      fields: listFields,
      hidden: ['id'],
    },
  },
  fields: [
    {
      title: 'id',
      source: 'id',
      ttoken: 'common.id',
      type: 'wholenum',
      readonly: true,
    },
    {
      title: 'jls_ime',
      source: 'jls_ime',
      ttoken: 'pp:registar_layer.jls_ime',
      type: 'text',
      filter: true,
      readonly: true,
      width: 'full',
    },
    {
      title: 'tip',
      source: 'tip',
      ttoken: 'pp:registar_layer.tip',
      type: 'text',
      filter: true,
      readonly: true,
    },
    {
      title: 'zu_ime',
      source: 'zu_ime',
      ttoken: 'pp:registar_layer.zu_ime',
      type: 'text',
      filter: true,
      readonly: true,
    },
    {
      title: 'jls_srediste',
      source: 'jls_srediste',
      ttoken: 'pp:registar_layer.jls_srediste',
      type: 'text',
      filter: true,
      readonly: true,
    },
    {
      title: 'jls_mb',
      source: 'jls_mb',
      ttoken: 'pp:registar.mbr_jls',
      type: 'numeric',
      filterType: 'text',
      filter: true,
      readonly: true,
    },
    {
      title: 'n_planova',
      source: 'n_planova',
      ttoken: 'pp:registar_layer.n_planova',
      type: 'numeric',
      filter: true,
      readonly: true,
    },
    {
      title: 'nova_generacija',
      source: 'has_nova_generacija',
      ttoken: 'pp:registar.nova_generacija',
      type: 'boolean',
      items: {
        labels: ['common.no', 'common.yes'],
        values: [false, true],
      },
      filter: true,
      readonly: true,
    },
    coreFields.geom,
  ],
};

export default JLS;
